import React, { useContext, useState } from 'react'
import { ColorsProvider } from 'app/react/components/colors/ColorsContext'

export default function ColorsContainer ({
  children,
  headerTitle = '',
  headerText = '',
  selectLabel = '',
  selectOptions = [],
  initialOption = '',
  showColorVariations = true,
  colors = [],
  buttonTexts = {},
  textBelow = ''
}) {

  const [selectedOption, setSelectedOption] = useState(initialOption)

  const contextObject = {
    headerTitle: headerTitle,
    headerText: headerText,
    selectLabel: selectLabel,
    selectOptions: selectOptions,
    selectedOption: selectedOption,
    setSelectedOption: setSelectedOption,
    showColorVariations: showColorVariations,
    colors: colors,
    buttonTexts: buttonTexts,
    textBelow: textBelow
  }

  return (
    <ColorsProvider value={contextObject}>
      {children}
    </ColorsProvider>
  )
}